
const HeroSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="space-y-6 md:space-y-8">
            <div className="inline-block border-2 border-primary-light px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <span className="text-xs md:text-sm font-semibold text-primary-light">NOTRE MISSION</span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-dark leading-tight">
              Connecter les agglomérations avec leurs solutions locales
            </h1>
            <p className="text-base md:text-lg lg:text-xl text-gray-dark leading-relaxed font-serif">
              Agglomération Solution est une agence dédiée à l'accompagnement des acteurs locaux. Nous croyons que chaque territoire possède ses propres dynamiques socio-économiques et mérite des solutions adaptées à ses spécificités.
            </p>
            <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
              Notre approche repose sur l'échange et l'écoute des besoins réels des particuliers et professionnels. Nous facilitons l'accès aux ressources, aux formations, aux partenariats et aux opportunités qui existent déjà dans votre agglomération, mais qui restent souvent méconnues.
            </p>
          </div>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/2215542284d08d5c71b43f8d1c870992.jpg"
                alt="Équipe Agglomération Solution"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
